import React, { useEffect, useState } from "react";
import { useGetContactTaskListQuery } from "src/services/ContactServices";
import TaskTabList from "./TaskTabList";
import { useParams } from "react-router-dom";

const TaskTabListWrapper = () => { 
  const { contactId } = useParams();
    const [contactData , setContactData] = useState<any>()

  const { data, isLoading, isFetching } = useGetContactTaskListQuery({
    limit: 10,
    searchValue: "",
    params: ["description"],
    page: 0,
    filterBy: [{
      fieldName :'contactId',
      value :[contactId]
  }],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  });

  useEffect(()=>{
    if(!isLoading && !isFetching){
        setContactData(data?.data) 
    }

  },[data, isLoading, isFetching ])

  return (
    <TaskTabList isLoading ={isLoading || isFetching} contactData={contactData} />
  )
};

export default TaskTabListWrapper;
